(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/react/contexts/container-context-provider.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/react/contexts/container-context-provider.js');

'use strict';

const {
  createContext,
  useContext,
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  CampaignContext
} = svs.numbergames.fractiongames.contexts;
const {
  createContainerSelectors
} = svs.numbergames.fractiongames.redux.slices.containers.selectors;
const ContainerContext = createContext({});
const ContainerContextProvider = _ref => {
  let {
    children,
    containerId
  } = _ref;
  const selectors = useMemo(() => createContainerSelectors(containerId), [containerId]);
  const {
    hasActiveCampaign,
    getCampaignInfo,
    getCampaignChances
  } = useContext(CampaignContext);
  const productNumeric = useSelector(selectors.selectProductNumeric);
  const drawNumber = useSelector(selectors.selectDrawNumber);
  const totalPrice = useSelector(selectors.selectTotalPrice);
  const game = useSelector(selectors.selectGame);
  const containerHasActiveCampaign = useMemo(() => hasActiveCampaign(productNumeric, drawNumber), [hasActiveCampaign, productNumeric, drawNumber]);
  const containerCampaignInfo = useMemo(() => getCampaignInfo(productNumeric, drawNumber), [getCampaignInfo, productNumeric, drawNumber]);
  const containerCampaignChances = useMemo(() => getCampaignChances({
    productNumeric,
    drawNumber,
    totalPrice,
    game
  }), [getCampaignChances, productNumeric, drawNumber, totalPrice, game]);
  return React.createElement(ContainerContext.Provider, {
    value: {
      selectors,
      hasActiveCampaign: containerHasActiveCampaign,
      campaignInfo: containerCampaignInfo,
      campaignChances: containerCampaignChances
    }
  }, children);
};
Object.assign(svs.numbergames.fractiongames.contexts, {
  ContainerContext,
  ContainerContextProvider
});

 })(window);